import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0569a060&"
import script from "./goods.js?vue&type=script&lang=js&"
export * from "./goods.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports